var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 20.1667C12.0128 20.1667 12.8337 19.3459 12.8337 18.3333C12.8337 17.3208 12.0128 16.5 11.0003 16.5C9.9878 16.5 9.16699 17.3208 9.16699 18.3333C9.16699 19.3459 9.9878 20.1667 11.0003 20.1667Z",
    fill: "#273896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 5.50016C12.0128 5.50016 12.8337 4.67935 12.8337 3.66683C12.8337 2.65431 12.0128 1.8335 11.0003 1.8335C9.9878 1.8335 9.16699 2.65431 9.16699 3.66683C9.16699 4.67935 9.9878 5.50016 11.0003 5.50016Z",
    fill: "#273896"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81478 18.0187C6.8273 18.0187 7.64811 17.1979 7.64811 16.1854C7.64811 15.1729 6.8273 14.3521 5.81478 14.3521C4.80226 14.3521 3.98145 15.1729 3.98145 16.1854C3.98145 17.1979 4.80226 18.0187 5.81478 18.0187Z",
    fill: "#273896"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1859 7.64762C17.1984 7.64762 18.0192 6.82681 18.0192 5.81429C18.0192 4.80177 17.1984 3.98096 16.1859 3.98096C15.1734 3.98096 14.3525 4.80177 14.3525 5.81429C14.3525 6.82681 15.1734 7.64762 16.1859 7.64762Z",
    fill: "#273896"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66628 12.834C4.67931 12.834 5.50053 12.0128 5.50053 10.9998C5.50053 9.98675 4.67931 9.16553 3.66628 9.16553C2.65325 9.16553 1.83203 9.98675 1.83203 10.9998C1.83203 12.0128 2.65325 12.834 3.66628 12.834Z",
    fill: "#273896"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 12.8332C19.3459 12.8332 20.1667 12.0124 20.1667 10.9998C20.1667 9.98732 19.3459 9.1665 18.3333 9.1665C17.3208 9.1665 16.5 9.98732 16.5 10.9998C16.5 12.0124 17.3208 12.8332 18.3333 12.8332Z",
    fill: "#273896"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81478 7.6486C6.8273 7.6486 7.64811 6.82779 7.64811 5.81527C7.64811 4.80274 6.8273 3.98193 5.81478 3.98193C4.80226 3.98193 3.98145 4.80274 3.98145 5.81527C3.98145 6.82779 4.80226 7.6486 5.81478 7.6486Z",
    fill: "#273896"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1859 18.0197C17.1984 18.0197 18.0192 17.1989 18.0192 16.1864C18.0192 15.1738 17.1984 14.353 16.1859 14.353C15.1734 14.353 14.3525 15.1738 14.3525 16.1864C14.3525 17.1989 15.1734 18.0197 16.1859 18.0197Z",
    fill: "#273896"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderDot);
export default __webpack_public_path__ + "static/media/loader-dot.9961b07f3e155776d30379c79fbbc4ae.svg";
export { ForwardRef as ReactComponent };